import { AgentSearch, AgentSearchProps } from 'components/agent-search';
import { getStringFromRequestCookie } from 'utils/cookies';
import { CountryCode, CountryCodeList } from 'types/countries';
import HeadData from 'components/head-data';
import Layout from 'components/layout';
import { v4 as uuid } from 'uuid';
import usePreventPrint from 'hooks/usePreventPrint';

import type { GetServerSidePropsContext } from 'next';
import { SITE_LOCATION_COOKIE_NAME } from 'constants/cookies';
import { TenantTypes } from 'tenants';
import { createGetServerSideProps, HandlerType } from 'utils/next/shared-getServerSideProps';
import { FeaturesType } from 'contexts/features';
import { NOT_FOUND } from 'constants/not-found';


const handler: HandlerType<AgentSearchProps> = async (context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  if (!tenant.features.AgentSearch) {
    return NOT_FOUND;
  }

  const { location, country } = context.query;
  const sessionId = uuid();

  let title = 'Find a Local Real Estate Agent | eXp Realty®';
  let metaDescription = "Find real estate listings for sale in Canada. Search MLS real estate listings for homes, condos and properties on exprealty.ca, Canada's top real estate website.";

  if (tenant) {
    title = `Find a Local Real Estate Agent ${tenant.theme.title}`;
    metaDescription = tenant.theme.metaDescription;
  }

  const storedSiteLocation = getStringFromRequestCookie(SITE_LOCATION_COOKIE_NAME, context.req) as CountryCode;
  const storedCountry = (
    country && typeof country === 'string' && (country === CountryCodeList.CANADA || country === CountryCodeList.UNITED_STATES))
    ? country
    : storedSiteLocation === CountryCodeList.UNITED_STATES ? CountryCodeList.UNITED_STATES : CountryCodeList.CANADA;

  let decodedLocation: string;

  if (location && typeof location === 'string' && location.length > 0) {
    decodedLocation = decodeURIComponent(location);
  }

  return {
    props: {
      initialLocation: decodedLocation || null,
      initialCountry: storedCountry,
      sessionId,
      tenantId: tenant.id,
      headerData: {
        title,
        metaDescription,
      },
    },
  };
};


export const getServerSideProps = createGetServerSideProps<AgentSearchProps>(handler);


export default function AgentsPage(props: AgentSearchProps) {
  usePreventPrint();

  return (
    <Layout>
      <HeadData data={props.headerData} />
      <AgentSearch {...props} />
    </Layout>
  );
}